module.exports = __webpack_public_path__ + "img/4.e3170f64.png";